import { useEffect, useState } from "react";
import { api } from "./api";
import { DEFAULT_SITE } from "../config/academy";
import { LANDING_DEFAULTS } from "../config/landingText";

let cache = null;
let pending = null;
const subs = new Set();

export const setSiteCache = (data) => { cache = data; subs.forEach((fn) => fn(data)); };
export const loadSite = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) pending = api.get("/site").then((r) => { setSiteCache(r.data); return r.data; }).catch(() => DEFAULT_SITE).finally(() => { pending = null; });
  return pending;
};
export function useSite() {
  const [site, setSite] = useState(cache || DEFAULT_SITE);
  useEffect(() => { subs.add(setSite); loadSite().then(setSite); return () => subs.delete(setSite); }, []);
  return site;
}
export const waIntl = (n) => (n || "").replace(/\D/g, "").replace(/^0/, "62");

// ---- editable landing copy
const fill = (s, vars) => (vars ? s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m)) : s);
/** t("hero.title", { name }) -> admin text (site.texts) or default. */
export function useT() {
  const site = useSite();
  return (key, vars) => { const v = site.texts?.[key]; return fill(typeof v === "string" ? v : LANDING_DEFAULTS[key] ?? "", vars); };
}
/** Render *accent* as <em> and **bold** as <b> (no HTML is interpreted). */
export function Rich({ text }) {
  return (text || "").split(/(\*\*[^*]+\*\*|\*[^*\n]+\*)/g).map((part, i) => part.startsWith("**") && part.endsWith("**") && part.length > 4 ? <b key={i}>{part.slice(2, -2)}</b> : part.startsWith("*") && part.endsWith("*") && part.length > 2 ? <em key={i}>{part.slice(1, -1)}</em> : part);
}
